import { render, staticRenderFns } from "./AddClusterForm.vue?vue&type=template&id=22b6424d"
import script from "./AddClusterForm.vue?vue&type=script&lang=js"
export * from "./AddClusterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports